import {IUpdateTimerAction} from './types/timer.action.types';

export const UPDATE_TIMER = 'UPDATE_TIMER';

export const updateTimerAction = (timeElapsed: number): IUpdateTimerAction => ({
    type: UPDATE_TIMER,
    payload: timeElapsed,
});
